import { SimpleGrid, Box } from '@mantine/core';
import { DemoBanner } from './DemoBanner';
import { WelcomeHeader } from './WelcomeHeader';
import { QuickActions } from './QuickActions';
import { StatsRow } from './StatsRow';
import { AttentionPanel } from './AttentionPanel';
import { LiveActivityPanel } from './LiveActivityPanel';
import { ActiveCampaigns } from './ActiveCampaigns';

export function HomePage() {
  return (
    <Box mx="auto">
      <DemoBanner />
      <WelcomeHeader />
      <QuickActions />
      <StatsRow />

      <SimpleGrid cols={{ base: 1, md: 2 }} spacing={{ base: 'xl', md: 48 }} my={32}>
        <AttentionPanel />
        <LiveActivityPanel />
      </SimpleGrid>

      <ActiveCampaigns />
    </Box>
  );
}

export default HomePage;
